export default __webpack_public_path__ + "static/media/bannerTwox2.591da0db.png";